// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const ico: CountryValidator<"SK"> = createValidator(
  "sk.ico",
  161,
);

export default ico;
export const compact = ico.compact;
export const format = ico.format;
export const validate = ico.validate;
export const generate = (): string =>
  ico.generate?.() ??
  (() => {
    throw new Error(
      "Validator sk.ico cannot generate values",
    );
  })();
